/**
 * MedalDisc — the V.I.P. medal (bronze / silver / gold / platinum), as the
 * scheduler's patient pop-up shows it and Admin > V.I.P. Program edits its
 * thresholds. The colours mirror the four `tag_sm_*.png` images legacy served
 * from `../images/`.
 */
import { Award } from 'lucide-react';
import { cn } from '@/lib/utils';

export type MedalTier = 'bronze' | 'silver' | 'gold' | 'platinum';

export const MEDAL_COLORS: Record<MedalTier, { bg: string; border: string }> = {
  bronze: { bg: '#cd7f32', border: '#8b572a' },
  silver: { bg: '#c0c0c0', border: '#8e8e8e' },
  gold: { bg: '#d4af37', border: '#a08524' },
  platinum: { bg: '#b9f2ff', border: '#7fc1d6' },
};

export function MedalDisc({ tier, tooltip, size = 'sm' }: { tier: MedalTier; tooltip?: string | null; size?: 'sm' | 'lg' }) {
  const c = MEDAL_COLORS[tier];
  return (
    <span
      title={tooltip ?? `${tier[0].toUpperCase()}${tier.slice(1)} Level Patient`}
      className={cn('inline-flex shrink-0 items-center justify-center rounded-full', size === 'lg' ? 'h-16 w-16 shadow-sm' : 'h-5 w-5')}
      style={{ background: c.bg, border: `${size === 'lg' ? 3 : 2}px solid ${c.border}` }}
      aria-label={`${tier} medal`}
    >
      <Award className={cn('text-white drop-shadow', size === 'lg' ? 'h-8 w-8' : 'h-3 w-3')} />
    </span>
  );
}
